const commonMessages = {
  messages: {
    added: 'added',
    addProvider: 'Add Provider',
    addPaymentMethods: 'Add Payment Method',
    addBonusBundle: 'Add Bonus Bundle',
    addBrand: 'Add Brand',
    addGames: 'Add Games',
    approved: 'approved',
    assigned: 'assigned',
    assign: 'assign',
    calculate: 'calculate',
    calculateRolloverMessage:
      'The rollover is going to get calculated now. Depending on the amount of bets, this operation might take a few minutes. Please return in a bit to see the results',
    companyError: 'Please select a company.',
    completed: 'completed',
    confirmAction: 'Are you sure you want to {{action}} this {{item}}?',
    confirmCheckIsSamePlayer:
      'There is already a player with the same name, last name and date of birth. Do you still want to save the changes?',
    confirmActionCannotReverse: 'This action cannot be reversed.',
    copiedSuccessfully: 'Item successfully copied.',
    copiedClipboardMessage: 'Please select an item to copy it in the clipboard',
    create: 'create',
    created: 'created',
    createdSuccessfully: 'The {{item}} has been created successfully',
    declined: 'declined',
    delete: 'delete it',
    deleted: 'deleted',
    deletedSuccessfully: 'The {{item}} has been deleted successfully',
    discard: 'discard',
    duplicate: 'duplicate',
    duplicated: 'duplicated',
    emailSizeError: 'The email provided is too long.',
    emailSendTest: 'Please add an email and select a language to send a test',
    errorAction:
      'An error occurred while trying to {{action}} the {{item}}. Please try again later.',
    errorOccurred: 'An error has occurred. Please try again.',
    errorOccurredName:
      'An error has occurred. Please make sure the template name is unique and try again',
    errorOccurredFind:
      'An error has occurred. Please try again with other filters',
    fileSizeError: 'The file provided is too big.',
    forfeit: 'forfeit',
    formatError: 'Please provide a valid {{field}}.',
    formatErrorUserList:
      'Incorrect list format, please separate items by commas.',
    gameAlreadyAdded: 'This game is already added',
    homeTitle: 'Welcome back!',
    noSpaces: 'No spaces allowed',
    selectAccountStatusFirst: 'You must select an Account Status first.',
    selectDefaultOptionSelectedError: 'You must select a {{selectName}} first.',
    load: 'load',
    generated: 'generated',
    incompleteFields: 'Some required information is missing or incomplete.',
    inputCompleteLength:
      '{{field}} must have a min of {{min}} and a max of {{max}} characters.',
    inputMaxLength: '{{field}} must have a max of {{max}} characters.',
    invalidCredentials: 'Please verify your credentials.',
    leavePageConfirmation: 'Are you sure you want to leave this page?',
    noResultsFound: 'Looks like there are no entries here yet.',
    tryRemovingFilters: 'Try Removing filter or come back later',
    noData: 'No Data',
    notAllowed: 'Character not allowed',
    processed: 'processed',
    pickEmoji: 'Pick you emoji',
    recover: 'recover',
    recovered: 'recovered',
    reverted: 'reverted',
    remove: 'remove',
    reset: 'reset',
    saved: 'saved',
    sent: 'sent',
    sessionEnded: 'Session ended.',
    stayOnThisPage: 'Stay on this page',
    successfully: 'The {{item}} has been {{what}} successfully.',
    successfullyPlural: 'The {{item}} have been {{what}} successfully.',
    testEmailSuccessfully: 'The email test has been sent successfully.',
    sync: 'sync',
    update: 'update',
    updated: 'updated',
    updatedSuccessfully: 'The {{item}} has been updated successfully',
    uploaded: 'uploaded',
    validateStartTime: 'The start time should be greater than local time',
    validateEndTime: 'The end time must be greater than the start time',
    willLoseInformation: 'In doing so, you will lose all unsaved changes.',
    unassign: 'unassign',
  },
}
export default commonMessages
